import { render, staticRenderFns } from "./Luangnamtha.vue?vue&type=template&id=7b4258a3&"
import script from "./Luangnamtha.vue?vue&type=script&lang=js&"
export * from "./Luangnamtha.vue?vue&type=script&lang=js&"
import style0 from "./Luangnamtha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports